import {z} from 'zod';

export const redriveResponseSchema = z.object({
  status: z.string(),
  data: z.object({
    redrivenCount: z.number(),
    failedCount: z.number(),
  }),
  timestamp: z.string(),
});
